export default {
  methods: {
    arrayGet: function (list, key) {
      if (key.includes('.')) {
        let keys = key.split('.')
        for (let j in keys) {
          let next = keys[j]
          list = list[next]
        }
        return list
      } else {
        return list[key]
      }
    },

    setHierarchy: function (name, value, fields) {
      let keys = name.split('.')
      let key = keys.shift()
      if (typeof fields[key] == 'undefined') {
        fields[key] = {}
      }
      if (keys.length === 1) {
        fields[key][keys.shift()] = value
      } else {
        fields[key] = this.setHierarchy(keys.join('.'), value, fields[key])
      }
      return fields
    },

    valueAsArray: function (list) {
      let fields = {}
      for (let name in list) {
        let value = list[name]
        if (name.includes('.')) {
          fields = this.setHierarchy(name, value, fields)
        } else {
          fields[name] = value
        }
      }
      return fields
    },

    getValueFromFields() {
      let value = {}
      for (let i = 0; i < this.fields.length; i++) {
        if (this.fields[i].value !== undefined) {
          value[this.fields[i].name] = this.fields[i].value
        }
      }
      value = this.valueAsArray(value)
      return value
    },
    getFieldsList() {
      return this.fields
    },

    getFieldByName(fields, name) {
      for (let i = 0; i < fields.length; i++) {
        let field = fields[i]
        if (field.name == name) {
          return fields[i]
        }
      }
    },

    getFieldValue(fields, name) {
      let field = this.getFieldByName(fields, name)
      if (field) {
        return field.value
      }
    },

    getFloatValue(fields, name) {
      let valueN = Number(this.getFieldValue(fields, name))
      if (valueN != 'NaN') {
        return valueN
      }
      return 0
    },

    defineFieldsFromConfig: function (fields, config, fieldNames) {
      fields.splice(0)
      for (let i = 0; i < fieldNames.length; i++) {
        let field = fieldNames[i]
        if (this.arrayGet(config, field)) {
          this.$root.addValue(fields, this.arrayGet(config, field))
          this.setValue(fields[fields.length - 1], 'name', field)
          this.setValue(fields[fields.length - 1], 'value', '')
        }
      }
    },

    setFieldsValues: function (fields, jsonContent) {
      for (let i = 0; i < fields.length; i++) {
        let value = this.arrayGet(jsonContent, fields[i].name)
        if (typeof value != 'undefined') {
          if (value != null && typeof value == 'object') {
            if (typeof value.id != 'undefined') {
              this.setValue(fields[i], 'value', value.id)
            } else if (typeof value.internalName != 'undefined') {
              this.setValue(fields[i], 'value', value.internalName)
            }
          } else {
            this.setValue(fields[i], 'value', value)
          }
        }
      }
    },

    defineForm: function (fields, config, jsonContent, fieldNames) {
      this.defineFieldsFromConfig(fields, config, fieldNames)
      this.setFieldsValues(fields, jsonContent)
    },
  },
}
